import React, { useCallback, useState } from "react";
import { App, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  addDefaultClient,
  clearClientInfo,
  deleteDefaultClient,
  searchEmail,
  setDefaultClientOpenAdd,
  setDefaultClientOpenEdit,
  setDefaultClientSelected,
  setSearchById,
  updateDefaultClient,
} from "store/user/(default)/client/default_client.action";
import {
  defaultClientAllSelector,
  defaultClientInfoSelector,
  defaultClientSearchSelector,
  defaultClientSelectedSelector,
} from "store/user/(default)/client/default_client.selector";
import { handleSearchUser } from "store/user/algolia/algolia.action";

//
//component
//redux
//selector

//actions

//utils
//hook
//str

const { confirm } = Modal;

// ========= search user detail ================//
export const useClientSearch = () => {
  const { message } = App.useApp();
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------

  // search collection
  const handleSearchByEmail = useCallback(({ email }) => {
    setLoading(true);
    dispatch(
      searchEmail({ email }, (res) => {
        setLoading(false);
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  }, [dispatch, message])

  
  const handleSearchById = useCallback( ({ id }) => {
    console.log({ id });
    setLoading(true);
    dispatch(
      setSearchById({ id }, (res) => {
        setLoading(false);
        console.log({ id, res });
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  }, [dispatch, message])

  const handleRemoveClient = () => {
    dispatch(clearClientInfo());
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleSearchByEmail, handleRemoveClient, handleSearchById };
};

export const useClientAdd = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const clientInfo = useSelector(defaultClientInfoSelector);
  // -------------------------- FUNCTION ------------------------
  const handleOpenAdd = () => {
    dispatch(setDefaultClientOpenAdd(true));
  };

  const handleCloseAdd = (form) => {
    dispatch(setDefaultClientOpenAdd(false));
    dispatch(clearClientInfo());
    form?.resetFields();
  };

  const handleAdd = (form) => {
    form
      .validateFields()
      .then((values) => {
        if (values && clientInfo) {
          const id = clientInfo?.uid;
          const { clients, note } = values;
          setLoading(true);
          dispatch(
            addDefaultClient({ id, note, clients }, (response) => {
              setLoading(false);
              if (response.status === 200) {
                message.success("Thêm khách hàng thành công");
                handleCloseAdd(form);
              } else if (response.status === 500) {
                message.error(response.data);
              }
            }),
          );
        }
      })
      .catch((err) => {
        message.error(err?.message || "Vui lòng thử lại lần sau");
      });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleOpenAdd, handleCloseAdd, handleAdd };
};

//edit
export const useClientEdit = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const selected = useSelector(defaultClientSelectedSelector);
  // -------------------------- FUNCTION ------------------------
  const handleOpenEdit = (data) => {
    dispatch(setDefaultClientSelected(data));
    dispatch(setDefaultClientOpenEdit(true));
  };

  const handleCloseEdit = (form) => {
    dispatch(setDefaultClientOpenEdit(false));
    form?.resetFields();
  };

  const handleEdit = (form) => {
    form
      .validateFields()
      .then((values) => {
        if (values && selected) {
          setLoading(true);
          dispatch(
            updateDefaultClient({ update: values }, (response) => {
              setLoading(false);
              if (response.status === 200) {
                message.success("Cập nhật khách hàng thành công");
                handleCloseEdit(form);
              } else if (response.status === 500) {
                message.error(response.data);
              }
            }),
          );
        }
      })
      .catch((err) => {
        message.error(err?.message || "Vui lòng thử lại lần sau");
      });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleOpenEdit, handleCloseEdit, handleEdit };
};

//delete
export const useClientRemove = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------

  const showConfirmDelete = (data) => {
    confirm({
      title: "Bạn có muốn xoá khách hàng này không?",
      icon: <ExclamationCircleFilled />,
      onOk() {
        handleDelete(data);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleDelete = (data) => {
    const id = data?.id;
    console.log({ id });
    setLoading(true);
    dispatch(
      deleteDefaultClient({ id }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Xoá khách hàng thành công");
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    showConfirmDelete,
  };
};

// =========search & filter ================//
export const useClientRefine = () => {
  // -------------------------- VAR -----------------------------
  const fields = ["fullName", "email"];
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(defaultClientAllSelector);
  const search = useSelector(defaultClientSearchSelector);
  // -------------------------- FUNCTION ------------------------
  const refined = refineData(data, search, fields);

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return refined;
};

const refineData = (data, search, fields) => {
  let final = data || [];

  if (search !== "") {
    final = final?.filter((d) => {
      const string = combineValueSearch(fields, d);
      console.log({ string });
      const lowerName = string?.toLowerCase();
      const lowerSearch = search?.toLowerCase();
      const valids = lowerName?.includes(lowerSearch) || false;
      return valids;
    });
  }

  return final;
};

const combineValueSearch = (fields, d) => {
  let finalStr = "";

  fields?.forEach((field) => {
    const value = d[field] || null;
    if (value) {
      finalStr += `@${value}`;
    }
  });

  return finalStr;
};
